import React from 'react'
import { Tooltip } from 'antd';


function ImplementCard({ imageUrl }) {

    return (
        
        <div className="w-full py-2 my-4">
            <a href="#" target="_blank">
                <div className="bg-white shadow rounded-lg hover:shadow-lg overflow-hidden">
                    <div className="bg-cover bg-center h-32 p-1" style={{backgroundImage: `url(${imageUrl})`}}>
                    
                    </div>
                    <div className="p-2 mt-2">
                        <p className="font-bold text-purple-700 text-sm flex justify-center">
                            <span className="tracking-wide hover:text-purple-700"> Beri Mould Board Plough</span>
                        </p>
                        {/* <p className="text-gray-700 flex justify-center text-xs">
                            41-50 HP
                            </p> */}
                        <div className="flex items-center justify-center text-gray-700 border-t mt-1">
                            <svg className="fill-current w-3 h-3 mt-2" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path></svg>
                            <Tooltip title="PTO Horsepower">
                                <p className="text-xs text-gray-900 font-bold ml-1 mt-2">41-55HP</p>
                            </Tooltip>
                        </div>
                    </div>
                    
                    {/* <div className="px-4 pb-4">
                        <div className="">
                            <button className="px-3 py-2 w-full rounded items-center bg-transparent text-purple-700 font-semibold border-2 border-purple-700 text-xs hover:bg-purple-700 hover:text-white">
                                <span className="uppercase tracking-wider">Read More</span>
                            </button>
                        </div>
                    </div> */}
                </div>
            </a>
        </div>
    );
}

export default ImplementCard;
